var map = {
	"./de-bk-new.json": "2d86",
	"./de-bk.json": "8afd",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./zhHans.json": "ecd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";